(function () {
  const productsPerRow = () => {
    let userSelected = false; // flag to track manual click

    // Function to check if we're on desktop
    const isDesktop = () => window.innerWidth > 575;

    // Function to set default per-row based on device
    const setDefaultPerRow = () => {
      if (userSelected) return; // don't override user choice

      if (isDesktop()) {
        $('[data-per-row="large"]').removeClass("active");
        $('[data-per-row="small"]').addClass("active");
        $("[data-productis-in-row]").attr("data-productis-in-row", "small");
      } else {
        $('[data-per-row="small"]').removeClass("active");
        $('[data-per-row="large"]').addClass("active");
        $("[data-productis-in-row]").attr("data-productis-in-row", "large");
      }
    };

    // Set default on load
    setDefaultPerRow();
    $(window).on("resize", setDefaultPerRow);

    // Handle button clicks
    $(".per-row__button").click(function () {
      userSelected = true; // now user is in control
      $(".per-row__button").removeClass("active");
      $(this).addClass("active"); // simpler than lookup again
      $("[data-productis-in-row]").attr(
        "data-productis-in-row",
        $(this).data("per-row")
      );
    });
  };

  document.addEventListener("shopify:section:load", function () {
    productsPerRow();
  });

  productsPerRow();
})();